import './ProductCategoryInformation.scss';

import { Divider, DividerColor, Skeleton } from '@eliberty/design-system-react';

import { TextHTML } from '~atoms';
import { SlopesOverview } from '~molecules';
import { Maybe, ProductCategoryAdditionalInfo } from '~types/appsync.types';

interface Props {
  title?: string;
  additionalInfo?: Maybe<ProductCategoryAdditionalInfo>;
  isLoading?: boolean;
}

const ProductCategoryInformationMobile = ({ title, additionalInfo, isLoading = false }: Props) => {
  if (isLoading) {
    return (
      <div className='ProductCategoryInformation'>
        <div className='ProductCategoryInformation_images'>
          <Skeleton data-testid='Skeleton' height='230px' width={'100%'} radius={'8px'} />
        </div>
        <Skeleton data-testid='Skeleton' height='32px' width={'40%'} />
        <Skeleton data-testid='Skeleton' height='24px' width={'50%'} />
        <Skeleton data-testid='Skeleton' height='22px' width={'80%'} />
        <Skeleton data-testid='Skeleton' height='22px' width={'70%'} />
      </div>
    );
  }

  const isSlopesSummaryEmpty = (additionalInfo: ProductCategoryAdditionalInfo): boolean => {
    const {
      tagline,
      numBlackSlopes,
      numBlueSlopes,
      numGreenSlopes,
      numKmSlope,
      numRedSlopes,
      numSkiLift,
      numTotalSlopes,
    } = additionalInfo;

    return [
      tagline,
      numBlackSlopes,
      numBlueSlopes,
      numGreenSlopes,
      numKmSlope,
      numRedSlopes,
      numSkiLift,
      numTotalSlopes,
    ].every((value) => value === null);
  };

  return (
    <div className='ProductCategoryInformation'>
      <div className='ProductCategoryInformation_images'>
        <img src={additionalInfo?.image} alt='Domaine skiable' />
      </div>

      <div className='ProductCategoryInformation_content'>
        <h1 className='ProductCategoryInformation_title'>{title}</h1>
        {additionalInfo && (
          <>
            {!isSlopesSummaryEmpty(additionalInfo) && <Divider color={DividerColor.MediumGrey} />}
            <SlopesOverview
              tagline={additionalInfo.tagline}
              numTotalSlopes={additionalInfo.numTotalSlopes}
              numSkiLift={additionalInfo.numSkiLift}
              numKmSlope={additionalInfo.numKmSlope}
              numGreenSlopes={additionalInfo.numGreenSlopes}
              numBlueSlopes={additionalInfo.numBlueSlopes}
              numRedSlopes={additionalInfo.numRedSlopes}
              numBlackSlopes={additionalInfo.numBlackSlopes}
            />
            {additionalInfo.description && <Divider color={DividerColor.MediumGrey} />}
            {additionalInfo.description && <TextHTML text={additionalInfo.description} />}
          </>
        )}
      </div>
    </div>
  );
};

export default ProductCategoryInformationMobile;
